import React, { useEffect, useState } from "react";
import { Row, Col, DatePicker, Table, Card, Divider } from "antd";
import { apiCall } from "../../shared/helpers/networkHelper";
import moment from "moment";
import ErrorHandler from "../../shared/classes/ErrorHandler";

const { RangePicker } = DatePicker;

const diagnosisColumns = [
    { title: "Kode Diagnosa", dataIndex: "icd_skri", key: "icd_skri" },
    { title: "Nama Diagnosa", dataIndex: "icd_str", key: "icd_str" },
    { title: "Jumlah Pasien", dataIndex: "patient_count", key: "patient_count" }
];

const pageTitle = "Report Statistik RME - Laporan Diagnosa";

export default function Diagnosis() {
    const [dates, setDates] = useState([]);
    const [diagnosisData, setDiagnosisData] = useState([]);

    useEffect(() => {
        apiCall(
            `cashier/emr/statistic/patient-count/by-diagnosis?start_date=${moment(
                dates[0]
            ).format("YYYY-MM-DD")}&end_date=${moment(dates[1]).format(
                "YYYY-MM-DD"
            )}`,
            "GET",
            {},
            res => setDiagnosisData(res.data),
            err => ErrorHandler.handleGeneralError(err)
        );
    }, [dates]);

    return (
        <Card title={pageTitle} bordered={false}>
            {/* Date Filter */}
            <Row gutter={16}>
                <Col>
                    <RangePicker value={dates} onChange={setDates} />
                </Col>
            </Row>

            <Divider />

            {/* <Card style={{ marginBottom: 24 }} title="Laporan Diagnosa"> */}
            <Table
                rowKey="icd_10_id"
                columns={diagnosisColumns}
                dataSource={diagnosisData}
                pagination={false}
                bordered
            />
            {/* </Card> */}
        </Card>
    );
}

